
import React from 'react';

export const AddChatIcon = () => (
  <svg className="w-4 h-4" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 14.5C11.3137 14.5 14 11.8137 14 8.5C14 5.18629 11.3137 2.5 8 2.5C4.68629 2.5 2 5.18629 2 8.5C2 11.8137 4.68629 14.5 8 14.5Z" stroke="#1B1C1E" strokeMiterlimit="10" />
    <path d="M8 5.99854V11.0013" stroke="#1B1C1E" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.501 8.5H5.4982" stroke="#1B1C1E" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
